import React from 'react'
import PropTypes from 'prop-types'
import enhanceWithClickOutside from 'react-click-outside'

export class SelectField extends React.Component {
  static defaultProps = {
    disabled: false,
    options: [],
    valueProp: '',
    displayProp: ''
  }

  static propTypes = {
    /**
     * A string to display as the placeholder text.
     */
    placeholder: PropTypes.string,
    /**
     * An array of objects which will be used as the options for the select field.
     */
    options: PropTypes.array.isRequired,
    /**
     * The value of the option to be selected.
     */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /**
     * Which field in the option object will be used as the value of the select field.
     */
    valueProp: PropTypes.string.isRequired,
    /**
     * Which field in the option object will be used as the display of the select field.
     */
    displayProp: PropTypes.string.isRequired,
    /**
     * Which field in the option object will be used to determine whether the option should be hidden.
     */
    hideProp: PropTypes.string,
    /**
     * Whether the select field is disabled.
     */
    disabled: PropTypes.bool,
    /**
     * Optional styles to add to the select field.
     */
    optClass: PropTypes.string,
    /**
     * A callback function to be called when an option is selected.
     */
    changeCallback: PropTypes.func,
    /**
     * Text shown above the select field.
     */
    label: PropTypes.string,
    /**
     * An optional style object to render inline CSS.
     */
    style: PropTypes.object
  }

  state = {
    isOpen: false,
    value: this.props.value
  }

  componentWillMount = () => {
    // Select item
    if (this.state.value !== '' && this.getIndex(this.state.value, this.props.options) > -1) {
      this.selectItem(this.state.value, this.props.options)
    }
    // No value is passed in
    else {
      this.setState({selected: '', value: ''})
    }
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.value === this.state.value) {
      return
    }
    let validIndex = this.getIndex(nextProps.value, nextProps.options) > -1

    if (nextProps.value === undefined || nextProps.value === null || !validIndex) {
      this.setState({selected: '', value: ''})
    } else {
      this.selectItem(nextProps.value, nextProps.options)
    }
  }

  handleClickOutside = () => {
    if (this.state.isOpen) this.toggleSelectField()
  }

  toggleSelectField = () => {
    if (this.props.disabled) return

    this.setState({isOpen: !this.state.isOpen})
  }

  selectOption = (option, triggerCallback) => {
    this.setState({ selected: option, value: option[this.props.valueProp], isOpen: false }, () => {
      if (triggerCallback && typeof this.props.changeCallback === 'function') {
        this.props.changeCallback({
          target: {
            name: this.props.name,
            value: option[this.props.valueProp],
            option: option
          }
        })
      }
    })
  }

  selectItem = (value, options) => {
    let index = this.getIndex(value, options)

    if (index >= 0) {
      this.selectOption(options[index], false)
    }
  }

  getIndex = (value, options) => {
    let optionIndex = -1

    options.map((option, index) => {
      if (option[this.props.valueProp] === value) {
        optionIndex = index
      }
    })

    return optionIndex
  }

  getDisplayText = () => {
    if (this.state.selected !== '') {
      return this.state.selected[this.props.displayProp]
    }
    else if (typeof this.props.placeholder !== 'undefined') {
      return this.props.placeholder
    }
    return 'Please select an option'
  }

  render() {
    const disabledClass = this.props.disabled ? 'selectfield-disabled' : ''
    const activeClass = this.state.isOpen ? 'active' : ''
    const placeholderClass = this.state.value === '' ? 'placeholder' : ''
    const selectFieldClass = ['selectfield-component', activeClass, disabledClass, this.props.optClass, placeholderClass].join(' ')
    const { valueProp, hideProp, label, name } = this.props

    let options = this.props.options.map((option, index) =>
      <li
        key={index}
        onClick={this.selectOption.bind(null, option, true)}
        className={(hideProp && option[hideProp]) ? 'hidden' : undefined}
      >
        {option[this.props.displayProp]}
      </li>
    )

    if (options.length === 0) {
      options.push(<li key={0} className='not-clickable'>Nothing to select</li>)
    }

    let value = ''

    if (this.state.selected) {
      value = this.state.selected[valueProp]
    }

    return (
      <div className={selectFieldClass} style={this.props.style}>
        <input type='hidden' name={name} value={value} />
        <div className='selectfield-value' onClick={this.toggleSelectField}>
          <span className='display-text'>{this.getDisplayText()}</span>
        </div>
        <svg width="12px" height="7px" viewBox="0 0 12 7">
          <g id="0_1_1_D_Omisalj_ComingSoon_Landing" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-1308.000000, -18.000000)">
            <g id="Group-8" transform="translate(120.000000, 10.000000)" fill={this.props.caretColor} fillRule="nonzero">
              <g id="Group-6" transform="translate(984.000000, 0.000000)">
                <path d="M213.008579,6.90644068 C213.556126,6.90644068 214,6.4796694 214,5.95322034 C214,5.42677128 213.556126,5 213.008579,5 L206.991421,5 C206.443874,5 206,5.42677128 206,5.95322034 L206,12.0467797 C206,12.5732287 206.443874,13 206.991421,13 C207.538967,13 207.982841,12.5732287 207.982841,12.0467797 L207.982841,6.90644068 L213.008579,6.90644068 Z" id="Dropdown_icon" transform="translate(210.000000, 9.000000) rotate(-135.000000) translate(-210.000000, -9.000000) "></path>
              </g>
            </g>
          </g>
        </svg>
        <ul>
          {options}
        </ul>
      </div>
    )
  }
}

export default enhanceWithClickOutside(SelectField)



// WEBPACK FOOTER //
// ./src/js/SelectField.js